
import { useCallback } from 'react';

export const SkipLink = () => {
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <a
      href="#main-content"
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:absolute focus:z-[9999] focus:top-2 focus:left-2 focus:p-3 focus:bg-win95-blue focus:text-white focus:border-2 focus:border-win95-black focus:shadow-win95 focus:font-bold focus:text-sm"
    >
      Skip to main content
    </a>
  );
};
